"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSriTags = exports.getPublicPath = exports.getCssUrl = void 0;
var _url = _interopRequireDefault(require("url"));
var _path = require("path");
var _uiAssets = require("@concur/ui-assets");
var _config = _interopRequireDefault(require("../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var getCssUrl = exports.getCssUrl = function getCssUrl(lessSrcFile, theme) {
  var cdnUrl = _config.default.nui.assets.cdn.url;
  var useLocalDevAssetsServer = _config.default.nui.assets.shared.dev;
  return (0, _uiAssets.getLessCdnUrl)(lessSrcFile, cdnUrl, !useLocalDevAssetsServer, theme);
};
var getPublicPath = exports.getPublicPath = function getPublicPath(conf) {
  var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  var _conf$nui = conf.nui,
    assets = _conf$nui.assets,
    baseUrl = _conf$nui.baseUrl;
  if (assets.app.useCDN) {
    return _url.default.resolve(assets.cdn.url, (0, _path.join)(assets.cdn.path || baseUrl, assets.app.path, s));
  }
  return (0, _path.join)(baseUrl, assets.app.path, s);
};
var getSriTags = exports.getSriTags = function getSriTags(asset) {
  return asset !== null && asset !== void 0 && asset.file ? "crossorigin=\"anonymous\" integrity=\"".concat(asset.integrity, "\"") : 'crossorigin';
};